var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('loader-component',{attrs:{"with_text":true,"text":_vm.text,"text_class":"text-white"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }